import styled from '@emotion/styled';
import Color from '../theme/colors';

export default function getErrorDisplayStyles(shouldDisplayLogoDiv = true) {
  const defaultWidth = '400px';
  const CircleDiv = styled.div`
    width: 446px;
    height: 446px;
    background-color: ${Color.lightBlueGray};
    -moz-border-radius: 70px;
    -webkit-border-radius: 70px;
    border-radius: 50%;
    position: absolute;
  `;
  const TextContainer = styled.div`
    & div {
      align-self: center;
    }

    z-index: 10;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 446px;
    position: absolute;
  `;
  const ErrorCode = styled.div`
    color: ${Color.darkBlueGray};
    font-size: 140px;
    margin-top: ${shouldDisplayLogoDiv ? '-40px' : '-60px'};
  `;
  const ErrorName = styled.div`
    color: ${Color.blue};
    font-size: 28px;
    margin-top: ${shouldDisplayLogoDiv ? '-40px' : '-30px'};
  `;
  const ErrorDescription = styled.div`
    font-size: 17px;
    margin-top: 20px;
    width: ${defaultWidth};
  `;
  const LogoDiv = styled.div`
    font-size: 17px;
    margin-top: 40px;
    width: ${defaultWidth};
  `;
  const LogoLink = styled.div`
    color: ${Color.teal};
    font-size: 15px;
    width: ${defaultWidth};
  `;
  return [CircleDiv, TextContainer, ErrorCode, ErrorName, ErrorDescription, LogoDiv, LogoLink];
}
